import { render } from "./errorPage1.vue?vue&type=template&id=633eceed"
import script from "./errorPage1.vue?vue&type=script&lang=js"
export * from "./errorPage1.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__